import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Card,
  Cascader,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Radio,
  Row,
  Select,
} from 'antd';
import moment from 'moment';
import {
  queryDeleteTask,
  queryProjDirList,
  queryProjInfo,
  querySaveTask,
  queryTaskInfo,
} from '@api/task';
import { queryAccountList } from '@api/core/user';
import { queryDeleteAttachment } from '@api/pub/attachment';
import { BackBtn } from '@comm/BackBtn';
import TagsInput from '@comm/TagsInput';
import { setBackInfo } from '@store/modules/back_info';
import { setBackInfoStandby } from '@store/modules/back_info_standby';
import { queryWorkOrg } from '@api/hr/workOrg';
import TableFilesAddDel from './TableFilesAddDel';

const { RangePicker } = DatePicker;

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageType: '',
      projInfo: {},
      data: {},
      workOrgs: [],
      accountList: [],
      directoryList: [],
      isReleaseloLoading: false,
      typeList: [
        {
          uuid: '0',
          name: '绩效考核',
        },
        {
          uuid: '1',
          name: '政府申报',
        },
        {
          uuid: '2',
          name: '日常任务',
        },
      ],
      tags: [],
      executives: [],
      reviewers: [],
      viewables: [],
      assistants: [],
      isReview: 1,
      fileList: [{ id: 0 }],
      fileCount: 1,
      delFiles: [],
      newDirectoryUuid: '',
      newDirectoryName: '',
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.loadWorkOrgs();
    this.loadAccountList();
    const { path } = this.props.route;
    const { projectUuid } = this.props.location.query;
    const { taskUuid } = this.props.params;
    let pageType = '';
    switch (path) {
      case 'project_task_add':
        pageType = 'PTA';
        this.getProjInfo(projectUuid);
        this.loadDirectoryList(projectUuid);
        break;
      case 'project_task_edit/:taskUuid':
        pageType = 'PTE';
        this.getProjInfo(projectUuid);
        this.loadDirectoryList(projectUuid);
        this.loadData(taskUuid);
        break;
      case 'task_add':
        pageType = 'TA';
        break;
      case 'task_edit/:taskUuid':
        pageType = 'TE';
        this.loadData(taskUuid);
        break;
      default:
        break;
    }

    this.setState({
      pageType,
    });
  }

  // 获取业务部门列表
  loadWorkOrgs = () => {
    queryWorkOrg({ orgUuid: '' }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          workOrgs: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  // 获取人员列表
  loadAccountList = () => {
    queryAccountList().then(res => {
      if (res.statusCode === 200) {
        const newList = [];
        res.data.map(item => {
          newList.push({
            userName: item.name,
            userUuid: item.uuid,
          });
          return item;
        });
        this.setState({
          accountList: newList,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  // 获取项目信息
  getProjInfo = uuid => {
    queryProjInfo({ uuid }).then(res => {
      if (res.statusCode === 200) {
        const { administrators, reviewers, viewables, type, workorgName, workorgUuid } = res.data;

        // 设置人员列表（去除uuid 及设置默认值）
        const reviewersValue = [];
        administrators.map(item => {
          delete item.uuid;
          return uuid;
        });
        reviewers.map(item => {
          delete item.uuid;
          reviewersValue.push(item.userUuid);
          return item;
        });
        viewables.map(item => {
          delete item.uuid;
          return uuid;
        });
        this.setState({
          projInfo: res.data,
          reviewers,
          viewables,
        });

        this.props.form.setFieldsValue({
          reviewers: reviewersValue,
          workorgUuid,
          workorgName,
          type: `${type}`,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  // 获取任务信息
  loadData = uuid => {
    const { setFieldsValue } = this.props.form;
    queryTaskInfo({ uuid }).then(res => {
      if (res.statusCode === 200) {
        const {
          tags,
          executives,
          reviewers,
          assistants,
          taskFiles,
          workorgName,
          workorgUuid,
          type,
          isReview,
        } = res.data;
        const newTags = [];
        const assistantsValue = [];
        const reviewersValue = [];
        // 设置附件模板
        taskFiles &&
          taskFiles.map(item => {
            item.id = item.uuid;
            return item;
          });
        // 设置标签
        tags.map((item, index) => {
          newTags.push({
            uid: index,
            name: item,
          });
          return item;
        });
        // 设置人员默认值
        delete executives[0].uuid;
        reviewers.map(item => {
          delete item.uuid;
          reviewersValue.push(item.userUuid);
          return item;
        });
        assistants.map(item => {
          delete item.uuid;
          assistantsValue.push(item.userUuid);
          return item;
        });
        this.setState({
          data: res.data,
          tags: newTags,
          executives,
          assistants,
          reviewers,
          fileList: taskFiles,
          isReview,
        });
        setFieldsValue({
          executives: executives[0].userUuid,
          reviewers: reviewersValue,
          assistants: assistantsValue,
          workorgUuid,
          workorgName,
          type: `${type}`,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /** ---------------------------------目录设置开始-------------------------------------*/
  // 获取目录信息
  loadDirectoryList = uuid => {
    const { directoryUuid } = this.props.location.query;
    queryProjDirList({
      projectUuid: uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setDirList(res.data, []);
        this.setState(
          {
            directoryList: res.data || [],
          },
          () => {
            this.findDirList(this.state.directoryList, directoryUuid);
          },
        );
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  // 设置目录列表
  setDirList = (arr, parentValueArr) => {
    arr.map(item => {
      item.value = item.uuid;
      item.label = item.name;
      item.valueArr = parentValueArr.concat([item.value]);
      if (item.children) {
        this.setDirList(item.children, item.valueArr);
      }
      return item;
    });
  };

  // 查找目录信息
  findDirList = (arr, uuid) => {
    const { setFieldsValue } = this.props.form;
    arr.map(item => {
      if (uuid === item.uuid) {
        setFieldsValue({
          directoryUuid: item.valueArr,
        });
      } else if (item.children) {
        this.findDirList(item.children, uuid);
      }
      return item;
    });
  };

  // 改变目录
  changeDir = (value, option) => {
    this.setState({
      newDirectoryUuid: option[option.length - 1].uuid,
      newDirectoryName: option[option.length - 1].name,
    });
  };

  /** ---------------------------------目录设置结束-------------------------------------*/
  // 保存
  saveProj = status => {
    const {
      data,
      tags,
      isReview,
      pageType,
      fileList,
      reviewers,
      executives,
      assistants,
      newDirectoryUuid,
      newDirectoryName,
    } = this.state;
    const { projectUuid, projectName, directoryUuid, directoryName } = this.props.location.query;

    const params = {
      ...data,
      ...this.props.form.getFieldsValue(),
    };
    const newFileList = [];
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (status === 1) {
          this.setState({
            isReleaseloLoading: true,
          });
        } else {
          this.setState({
            isSaveloLoading: true,
          });
        }

        // 项目下任务设置项目uuid和目录uuid
        if (pageType === 'PTA' || pageType === 'PTE') {
          params.projectUuid = projectUuid;
          params.projectName = projectName;
          params.directoryUuid = newDirectoryUuid || directoryUuid;
          params.directoryName = newDirectoryName || directoryName;
        }

        // 处理附件模板
        fileList.map(item => {
          if (values[`name${item.id}`] && values[`files${item.id}`]) {
            newFileList.push({
              name: values[`name${item.id}`],
              files: values[`files${item.id}`],
            });
          }
          delete params[`name${item.id}`];
          delete params[`files${item.id}`];
          return item;
        });
        params.taskFiles = newFileList;

        // 设置标签
        const newTags = [];
        tags.map(item => {
          newTags.push(item.name);
          return item;
        });
        params.tags = newTags;
        params.executives = executives;
        params.reviewers = isReview ? reviewers : [];
        params.assistants = assistants;
        params.beginDate = values.date[0].format('YYYY-MM-DD');
        params.endDate = values.date[1].format('YYYY-MM-DD');
        params.status = status;
        delete params.date;
        querySaveTask(params).then(res => {
          if (res.statusCode === 200) {
            message.success(res.message);
            this.setBackPageInfo(status);
            this.props.router.go(-1);
          } else {
            message.error(res.message);
          }

          if (status === 1) {
            this.setState({
              isReleaseloLoading: false,
            });
          } else {
            this.setState({
              isSaveloLoading: false,
            });
          }
        });
        if (this.state.delFiles.length > 0) {
          this.state.delFiles.map(item => {
            queryDeleteAttachment({
              uuid: item.uuid,
            }).then(res => {});
            return item;
          });
        }
      }
    });
  };

  // 删除
  delProj = () => {
    const { taskUuid } = this.props.params;
    queryDeleteTask({ uuid: taskUuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.router.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  // 根据情况设置返回页面的信息
  setBackPageInfo = status => {
    const { pageType, newDirectoryUuid, newDirectoryName } = this.state;
    const { backInfo, backInfoStandby } = this.props;
    const { projectUuid, directoryUuid, directoryName } = this.props.location.query;
    if (backInfoStandby.path === `/task/project_detail_manage/${projectUuid}`) {
      const params = {};
      params.path = backInfoStandby.path;
      params.directoryUuid = newDirectoryUuid || directoryUuid;
      params.directory = newDirectoryName || directoryName;
      params.taskType = 'All';
      params.tabKey = '1';
      params.taskCurrent = 1;
      this.props.dispatch(setBackInfoStandby(params));
    }

    if (backInfo.path === `/task/task_launch`) {
      const params = {};
      params.path = backInfo.path;
      params.tabKey = status === 1 ? '1' : '3';
      params.status = status === 1 ? 'PUBLISH' : 'DRAFT';
      params.current = pageType === 'TA' ? 1 : backInfo.current;
      params.condition = pageType === 'TA' ? '' : backInfo.condition;
      this.props.dispatch(setBackInfo(params));
    }
  };

  // 设置项目类型
  handleSetTags = tags => {
    this.setState({ tags });
  };

  // 设置业务部门名称
  handleWorkorgChange = (value, option) => {
    this.props.form.setFieldsValue({
      workorgName: option.props.children,
    });
  };

  // 设置任务执行人
  changeExecutives = (value, option) => {
    this.setState({
      executives: [{ userUuid: value, userName: option.props.children }],
    });
  };

  // 设置任务审批人
  changeReviewers = value => {
    const { accountList } = this.state;
    const reviewers = [];
    value.map(item => {
      accountList.map(it => {
        if (it.userUuid === item) {
          reviewers.push(it);
        }
        return it;
      });
      return item;
    });

    this.setState({
      reviewers,
    });
  };

  // 设置任务协助人
  changeAssistants = value => {
    const { accountList } = this.state;
    const assistants = [];
    value.map(item => {
      accountList.map(it => {
        if (it.userUuid === item) {
          assistants.push(it);
        }
        return it;
      });
      return item;
    });

    this.setState({
      assistants,
    });
  };

  // 设置任务是否需要审批
  changeIsReview = e => {
    const { projInfo } = this.state;
    this.setState(
      {
        isReview: e.target.value,
      },
      () => {
        if (projInfo.uuid) {
          const reviewersValue = [];
          projInfo.reviewers.map(item => {
            reviewersValue.push(item.userUuid);
            return item;
          });
          this.props.form.setFieldsValue({
            reviewers: reviewersValue,
          });
        }
      },
    );
  };

  /** -------------------------------------设置附件模板列表开始--------------------------------*/
  // 新增一行
  addFiles = () => {
    const { fileList, fileCount } = this.state;
    fileList.push({ id: fileCount });
    this.setState({
      fileList,
      fileCount: fileCount + 1,
    });
  };

  // 删除该行
  deleteFiles = id => {
    const { fileList } = this.state;
    this.setState({
      fileList: fileList.filter(item => item.id !== id),
    });
  };

  // 文件删除
  fileRemove = file => {
    const { delFiles } = this.state;
    delFiles.push(file);
    this.setState({ delFiles });
  };
  /** -------------------------------------设置附件模板列表结束--------------------------------*/

  // 不可选择的时间
  disabledDate = current => {
    const { pageType, projInfo } = this.state;
    if (pageType === 'PTA' || pageType === 'PTE') {
      return current.valueOf() < projInfo.beginDate || current.valueOf() > projInfo.endDate;
    }
  };

  render() {
    const {
      data,
      tags,
      pageType,
      workOrgs,
      viewables,
      typeList,
      isReview,
      fileList,
      isReleaseloLoading,
      isSaveloLoading,
      accountList,
      reviewers,
      directoryList,
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    const ItemLayout = {
      labelCol: { span: 2 },
      wrapperCol: { span: 16 },
    };
    const ItemLayout2 = {
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
    };
    const ItemLayout3 = {
      labelCol: { span: 6 },
      wrapperCol: { span: 17 },
    };
    getFieldDecorator('workorgName', {
      initialValue: data.workorgName,
    });
    return (
      <div>
        <Form>
          <Row>
            <BackBtn />
            <Button
              type="primary"
              onClick={() => this.saveProj(1)}
              loading={isReleaseloLoading}
              icon="upload"
            >
              发布
            </Button>
            {!data.status || data.status === 0 ? (
              <Button
                type="primary"
                style={{ marginLeft: '10px' }}
                onClick={() => this.saveProj(0)}
                loading={isSaveloLoading}
                icon="snippets"
              >
                保存为草稿
              </Button>
            ) : null}
            {data.status === 0 ? (
              <Button style={{ marginLeft: '10px' }} onClick={this.delProj} icon="delete">
                删除
              </Button>
            ) : null}
          </Row>
          <Card style={{ marginTop: '10px' }}>
            <Form.Item label="任务名称" {...ItemLayout}>
              {getFieldDecorator('name', {
                rules: [{ required: true, message: '请填写任务名称' }],
                initialValue: data.name,
              })(<Input placeholder="请填写任务名称" />)}
            </Form.Item>
            <Row>
              <Col span={8}>
                <Form.Item label="任务周期" {...ItemLayout3}>
                  {data.uuid
                    ? getFieldDecorator('date', {
                        rules: [{ required: true, message: '请选择任务周期' }],
                        initialValue: [moment(data.beginDate), moment(data.endDate)],
                      })(<RangePicker disabledDate={this.disabledDate} />)
                    : getFieldDecorator('date', {
                        rules: [{ required: true, message: '请选择任务周期' }],
                      })(
                        <RangePicker disabledDate={this.disabledDate} style={{ width: '100%' }} />,
                      )}
                </Form.Item>
              </Col>
              <Col span={12}>
                {pageType === 'PTA' || pageType === 'PTE' ? (
                  <Form.Item label="所属目录" {...ItemLayout2}>
                    {getFieldDecorator('directoryUuid', {
                      rules: [{ required: true, message: '请选择任务所属目录' }],
                    })(
                      <Cascader changeOnSelect options={directoryList} onChange={this.changeDir} />,
                    )}
                  </Form.Item>
                ) : (
                  ''
                )}
              </Col>
            </Row>

            <Form.Item label="任务标签" {...ItemLayout}>
              {getFieldDecorator('tags')(
                <TagsInput tags={tags} handleSetTags={this.handleSetTags} />,
              )}
            </Form.Item>
            <Form.Item label="业务部门" {...ItemLayout}>
              {getFieldDecorator('workorgUuid', {
                rules: [{ required: true, message: '请选择业务部门' }],
              })(
                <Select
                  showSearch
                  disabled={!!(pageType === 'PTA' || pageType === 'PTE')}
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={this.handleWorkorgChange}
                >
                  {workOrgs.map(item => {
                    return <Select.Option key={item.uuid}>{item.name}</Select.Option>;
                  })}
                </Select>,
              )}
            </Form.Item>
            <Form.Item label="任务分类" {...ItemLayout}>
              {getFieldDecorator('type', {
                rules: [{ required: true, message: '请选择任务分类' }],
              })(
                <Select disabled={!!(pageType === 'PTA' || pageType === 'PTE')}>
                  {typeList.map(item => {
                    return <Select.Option key={item.uuid}>{item.name}</Select.Option>;
                  })}
                </Select>,
              )}
            </Form.Item>
            <Form.Item label="任务目标" {...ItemLayout}>
              {getFieldDecorator('aim', {
                initialValue: data.aim || null,
              })(<InputNumber style={{ width: '100%' }} />)}
            </Form.Item>
            <Form.Item label="任务描述" labelCol={{ span: 2 }} wrapperCol={{ span: 16 }}>
              {getFieldDecorator('remark', {
                rules: [{ required: true, message: '请填写任务描述' }],
                initialValue: data.remark,
              })(
                <Input.TextArea
                  placeholder="描述"
                  type="textarea"
                  autosize={{ minRows: 3, maxRows: 9 }}
                  maxLength={5000}
                />,
              )}
              <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入5000字</span>
            </Form.Item>
            <Form.Item label="附件模板" labelCol={{ span: 2 }} wrapperCol={{ span: 16 }}>
              {getFieldDecorator('fileTemplates')(
                <TableFilesAddDel
                  fileList={fileList}
                  addFiles={this.addFiles}
                  deleteFiles={this.deleteFiles}
                  fileRemove={this.fileRemove}
                  {...this.props}
                />,
              )}
            </Form.Item>
            <Form.Item label="任务执行方式" labelCol={{ span: 2 }} wrapperCol={{ span: 16 }}>
              {getFieldDecorator('isReview', {
                initialValue: data.isReview === 0 ? 0 : 1,
              })(
                <Radio.Group onChange={this.changeIsReview}>
                  <Radio value={1}>需要审批</Radio>
                  <Radio value={0}>无需审批</Radio>
                </Radio.Group>,
              )}
            </Form.Item>
            <Form.Item label="任务执行人" labelCol={{ span: 2 }} wrapperCol={{ span: 16 }}>
              {getFieldDecorator('executives', {
                rules: [{ required: true, message: '请选择管理员' }],
              })(
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={this.changeExecutives}
                >
                  {(pageType === 'PTA' || pageType === 'PTE' ? viewables : accountList).map(
                    item => {
                      return <Select.Option key={item.userUuid}>{item.userName}</Select.Option>;
                    },
                  )}
                </Select>,
              )}
            </Form.Item>
            {isReview ? (
              <Form.Item label="任务审批人" labelCol={{ span: 2 }} wrapperCol={{ span: 16 }}>
                {getFieldDecorator('reviewers', {
                  rules: [{ required: true, message: '请选择审批人' }],
                })(
                  <Select
                    showSearch
                    mode="multiple"
                    disabled={!!(pageType === 'PTA' || pageType === 'PTE')}
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={this.changeReviewers}
                  >
                    {(pageType === 'PTA' || pageType === 'PTE' ? reviewers : accountList).map(
                      item => {
                        return <Select.Option key={item.userUuid}>{item.userName}</Select.Option>;
                      },
                    )}
                  </Select>,
                )}
              </Form.Item>
            ) : (
              ''
            )}

            <Form.Item label="任务协助人" labelCol={{ span: 2 }} wrapperCol={{ span: 16 }}>
              {getFieldDecorator('assistants')(
                <Select
                  showSearch
                  mode="multiple"
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={this.changeAssistants}
                >
                  {(pageType === 'PTA' || pageType === 'PTE' ? viewables : accountList).map(
                    item => {
                      return <Select.Option key={item.userUuid}>{item.userName}</Select.Option>;
                    },
                  )}
                </Select>,
              )}
            </Form.Item>
          </Card>
        </Form>
      </div>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
  backInfoStandby: state.back_info_standby,
}))(Form.create()(Page));



// WEBPACK FOOTER //
// ./src/components/task/spTask/PageAdd.js